<script setup>
import SectionTop from "@/components/additional/SectionTop.vue";
import Slider from "@/components/slider/Slider.vue";
</script>

<template>
  <section class="what-we-do flex justify-between relative" id="what-we-do">
    <div class="what-we-do__content flex flex-col">
      <SectionTop>What We Do</SectionTop>
      <p class="text-ms" v-motion :initial="{ y: 10, opacity: 0 }" :visibleOnce="{ y: 0, scale: 1, opacity: 1 }" :duration="700">At the heart of Galazia’s ecosystem is our next-generation mobile application — a comprehensive platform designed for users seeking entertainment, speed, and simplicity.</p>
      <span class="text-ms" v-motion :initial="{ y: 10, opacity: 0 }" :visibleOnce="{ y: 0, scale: 1, opacity: 1 }" :duration="700" :delay="200">Available for players 18+ where local regulations permit.</span>
    </div>
    <Slider/>
  </section>
</template>

<style scoped lang="scss">
.what-we-do {
  overflow: hidden;
  padding: 9.722vw 8.333vw 5.556vw;
  gap: 2vw;
  z-index: 2;
  &__content {
    width: 40%;
    p {
      color: rgba(255, 255, 255, 0.70);
      margin: 3.472vw 0 0;
    }
    span {
      display: block;
      margin-top: auto;
    }
  }
}
@media (max-width: 768px) {
  .what-we-do {
    padding: 50px 24px;
    flex-direction: column;
    gap: 86px;
    &__content {
      width: 100%;
      p {
        margin: 48px 0 20px;
      }

    }
  }
}
</style>